import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operation-wrapper" }
const _hoisted_2 = { class: "operation-wrapper" }
const _hoisted_3 = { class: "operation-wrapper" }
const _hoisted_4 = { class: "operation-wrapper" }

import { ref, Ref, onMounted } from 'vue';
import { useStore }     from 'vuex';
import axios            from 'axios';
import { useI18n }          from 'vue-i18n';

// CONSTANTS
import CONSTAPIS           from '@/constants/apis';

// COMPONENTS

//INTERFACES
import { YAMLITEMS, YAMLOBJ, finalYAMLOBJ } from '@/interfaces/SmartLink/Equips';
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { TOKEN } from '@/constants/labels';
type FINALYAML = [string, YAMLOBJ];


export default /*@__PURE__*/_defineComponent({
  __name: 'YAMLMaintenance',
  setup(__props) {

const { t }                 = useI18n();
const store                 = useStore();
 
const finalCAMBIUM:Ref<YAMLITEMS[]> = ref([]);
const finalCISCO:Ref<YAMLITEMS[]>   = ref([]);
const finalMIKROTIK:Ref<YAMLITEMS[]>= ref([]);
const finalRAJANT:Ref<YAMLITEMS[]>  = ref([]);
const showEdit                      = ref(false);
const index                         = ref(0);
const typed                         = ref('');
const nameChange                    = ref('');
const status                        = ref('false');
const itemStatus                    = ref(['true','false']);

const searchFieldCAM                = ref();
const searchValueCAM                = ref("");
const searchFieldMIK                = ref();
const searchValueMIK                = ref("");
const searchFieldRAJ                = ref();
const searchValueRAJ                = ref("");
const searchFieldCIS                = ref();
const searchValueCIS                = ref("");


const HEADERS:HEADER[]   = [
{ text: 'Valor',        value: "value",       sortable: true, },
{ text: 'Name',         value: "name",        sortable: true, },
{ text: 'Estado',       value: "state",       sortable: true, },          
{ text: 'Edit',         value: "operation",   sortable: false, },          
];

const getYAML = async() => {
    await axios.get(CONSTAPIS.APIS.value.yaml.getYAML, { headers: { "Authorization": `Bearer ${TOKEN}`} }).then((yaml)=> {
    let cambium     = yaml.data.body.CAMBIUM;
    let cisco       = yaml.data.body.CISCO;
    let mikrotik    = yaml.data.body.MIKROTIK;
    let rajant      = yaml.data.body.RAJANT;

    let itemsCAMBIUMPrev :FINALYAML[]   = cambium   ? Object.entries(cambium) : [];
    let itemsCISCOPrev   :FINALYAML[]   = cisco     ? Object.entries(cisco) : [];
    let itemsMIKROTIKPrev:FINALYAML[]   = mikrotik  ? Object.entries(mikrotik) : [];
    let itemsRAJANTPrev  :FINALYAML[]   = rajant    ? Object.entries(rajant) : [];
    
    finalCAMBIUM.value      = getArrayYAML(itemsCAMBIUMPrev);
    finalCISCO.value        = getArrayYAML(itemsCISCOPrev);
    finalMIKROTIK.value     = getArrayYAML(itemsMIKROTIKPrev);
    finalRAJANT.value       = getArrayYAML(itemsRAJANTPrev);
    })
}

const getArrayYAML = (item:FINALYAML[]) => { 
    let memoryYAML:YAMLITEMS[] = []
    item.forEach((item:FINALYAML) => {
        memoryYAML.push({
            value   : item[0],
            name    : item[1].codename,
            state   : item[1].state
        })
    })
    return memoryYAML
}

const showEditDialog = (i:number, type: string, name:string, stat: string) => {
    showEdit.value      = true;
    index.value         = i;
    typed.value         = type;
    nameChange.value    = name;
    status.value        = stat;
}

const closeEditDialog = () => {
    showEdit.value      = false;
    index.value         = 0;
    typed.value         = '';
    nameChange.value    = '';
    status.value        = 'false';
}

const changeInfo = () => {
    if(typed.value === 'cam'){
        finalCAMBIUM.value[index.value-1].name      = nameChange.value;
        finalCAMBIUM.value[index.value-1].state     = status.value;
    }
    if(typed.value === 'raj'){
        finalRAJANT.value[index.value-1].name       = nameChange.value;
        finalRAJANT.value[index.value-1].state      = status.value;
    }
    if(typed.value === 'mik'){
        finalMIKROTIK.value[index.value-1].name     = nameChange.value;
        finalMIKROTIK.value[index.value-1].state    = status.value;
    }
    if(typed.value === 'cis'){
        finalCISCO.value[index.value-1].name        = nameChange.value;
        finalCISCO.value[index.value-1].state       = status.value;
    }
    closeEditDialog();
}

const changeYAML = async() => {
    let finalYAML:finalYAMLOBJ = {
        CAMBIUM     : {},
        CISCO       : {},
        MIKROTIK    : {},
        RAJANT      : {},
    }
    finalCAMBIUM.value.forEach((cambium:YAMLITEMS) => {
        finalYAML.CAMBIUM[cambium.value] = {
            codename    : cambium.name,
            state       : cambium.state
        }
    })
    finalCISCO.value.forEach((cisco:YAMLITEMS) => {
        finalYAML.CISCO[cisco.value] = {
            codename    : cisco.name,
            state       : cisco.state
        }
    })
    finalRAJANT.value.forEach((rajant:YAMLITEMS) => {
        finalYAML.RAJANT[rajant.value] = {
            codename    : rajant.name,
            state       : rajant.state
        }
    })
    finalMIKROTIK.value.forEach((mikrotik:YAMLITEMS) => {
        finalYAML.MIKROTIK[mikrotik.value] = {
            codename    : mikrotik.name,
            state       : mikrotik.state
        }
    })

    let params = { yaml : finalYAML }
    
    await axios.post(CONSTAPIS.APIS.value.yaml.editYAML,params,{ headers: { "Authorization": `Bearer ${TOKEN}`} }).then((yaml)=> {
        if(!yaml.data.error){
            store.dispatch('showSnackBar', {type: 'setSnackEdit', msg: 'YAML modificado'});
        }
    })
}


onMounted(async ()=>{
    await getYAML()
})
 
 
return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (finalCAMBIUM.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          class: "defaultCard",
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "titleDashboard" }, " Cambium ", -1)),
                _createVNode(_component_v_text_field, {
                  style: {"max-width":"400px"},
                  modelValue: searchValueCAM.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValueCAM).value = $event)),
                  label: _unref(t)('search'),
                  variant: "outlined",
                  density: "compact",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              "search-field": searchFieldCAM.value,
              "search-value": searchValueCAM.value,
              "table-class-name": "customize-table",
              "show-index": "",
              headers: HEADERS,
              items: finalCAMBIUM.value,
              "rows-per-page": 10
            }, {
              "item-operation": _withCtx((item) => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_icon, {
                    color: "#FC1050",
                    onClick: ($event: any) => (showEditDialog(item.index,'cam',item.name, item.state))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" mdi-pencil-plus ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["search-field", "search-value", "items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (finalMIKROTIK.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 1,
          class: "defaultCard",
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "titleDashboard" }, " mikrotik ", -1)),
                _createVNode(_component_v_text_field, {
                  style: {"max-width":"400px"},
                  modelValue: searchValueMIK.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValueMIK).value = $event)),
                  label: _unref(t)('search'),
                  variant: "outlined",
                  density: "compact",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              "search-field": searchFieldMIK.value,
              "search-value": searchValueMIK.value,
              "table-class-name": "customize-table",
              "show-index": "",
              headers: HEADERS,
              items: finalMIKROTIK.value,
              "rows-per-page": 10
            }, {
              "item-operation": _withCtx((item) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    color: "#FC1050",
                    onClick: ($event: any) => (showEditDialog(item.index,'mik',item.name, item.state))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" mdi-pencil-plus ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["search-field", "search-value", "items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (finalRAJANT.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 2,
          class: "defaultCard",
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "titleDashboard" }, " Rajant ", -1)),
                _createVNode(_component_v_text_field, {
                  style: {"max-width":"400px"},
                  modelValue: searchValueRAJ.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchValueRAJ).value = $event)),
                  label: _unref(t)('search'),
                  variant: "outlined",
                  density: "compact",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              "search-field": searchFieldRAJ.value,
              "search-value": searchValueRAJ.value,
              "table-class-name": "customize-table",
              "show-index": "",
              headers: HEADERS,
              items: finalRAJANT.value,
              "rows-per-page": 10
            }, {
              "item-operation": _withCtx((item) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_icon, {
                    color: "#FC1050",
                    onClick: ($event: any) => (showEditDialog(item.index,'raj',item.name, item.state))
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode(" mdi-pencil-plus ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["search-field", "search-value", "items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (finalCISCO.value.length > 0)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 3,
          class: "defaultCard",
          color: "bgtopology"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "titleDashboard" }, " cisco ", -1)),
                _createVNode(_component_v_text_field, {
                  style: {"max-width":"400px"},
                  modelValue: searchValueCIS.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchValueCIS).value = $event)),
                  label: _unref(t)('search'),
                  variant: "outlined",
                  density: "compact",
                  "hide-details": ""
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_EasyDataTable, {
              "search-field": searchFieldCIS.value,
              "search-value": searchValueCIS.value,
              "table-class-name": "customize-table",
              "show-index": "",
              headers: HEADERS,
              items: finalCISCO.value,
              "rows-per-page": 10
            }, {
              "item-operation": _withCtx((item) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    color: "#FC1050",
                    onClick: ($event: any) => (showEditDialog(item.index,'cis',item.name, item.state))
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" mdi-pencil-plus ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["search-field", "search-value", "items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, {
      class: "ma-4",
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "success",
          onClick: changeYAML
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode(" enviar ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showEdit.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showEdit).value = $event)),
      width: "80%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, {
          color: "background",
          class: "defaultCard"
        }, {
          default: _withCtx(() => [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "subtitleDashboard" }, "Editar el producto ", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_v_row, { class: "ma-0 mt-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0 pr-2",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: nameChange.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((nameChange).value = $event)),
                      label: _unref(t)('search'),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  class: "pa-0 pl-2",
                  cols: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: status.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((status).value = $event)),
                      items: itemStatus.value,
                      label: 'status',
                      variant: "outlined",
                      density: "compact",
                      "hide-details": ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              class: "mt-6 mb-2 mx-1",
              justify: "end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: changeInfo,
                  color: "success"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("guardar", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})